function CloudBookshelfRepository() { }

CloudBookshelfRepository.prototype.getHeaderMenuVisibility = async () => {
  return true;
};

export default new CloudBookshelfRepository();